import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { getTextColorClassUsers, getRoleName } from '../utils/formats';
import AdminBranchRolesComponent from './AdminBranchRolesComponent';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { getSelectedBranchId } from '../utils/branch';

var config = process.env;

function sanitizeEmailForId(mail = '') {
    return String(mail).replace(/[.@\-_]/g, '');
}

class TableProductsComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'firstName',
            sortDir: 'asc',
            data: [],
            loaded: false
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        const selectedBranchId = getSelectedBranchId();
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            branchId: selectedBranchId || undefined,
        });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}admin?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true
                });
            }
        });
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    createModals = () => {
        if (!this.state.loaded) {
            return null;
        }

        return (
            <div>
                {this.state.data.map((data) => (
                    <React.Fragment key={data.email}>
                        {this.createModalRemove(data.email, data.firstName, data.lastName)}
                        {this.createModalEdit(data.email, data.firstName, data.lastName, data.role)}
                        {this.createModalBranches(data.email, data.firstName, data.lastName)}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    createModalBranches = (mail, firstName, lastName) => {
        var email = sanitizeEmailForId(mail);
        return (
            <div className="modal fade" id={`modal-branches-${email}`} role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>Roles por sucursal</h4>
                        </div>
                        <div className="modal-body">
                            <AdminBranchRolesComponent
                                email={mail}
                                name={`${firstName} ${lastName}`}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    createModalRemove = (mail, firstName, lastName) => {
        var email = sanitizeEmailForId(mail);
        return (
            <div className="modal fade" id={`modal-remove-${email}`} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>Eliminar</h4>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro que deseas eliminar al administrador?</p>
                            <p style={{ marginBottom: '7px' }}><b>Nombre:</b> {firstName} {lastName}</p>
                            <p><b>Correo:</b> {mail}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cancelar
                            </button>
                            <button
                                className="mb-2 mr-1 btn btn-primary btn-sm"
                                data-dismiss="modal"
                                onClick={() => this.onDeleteItem(mail)}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    createModalEdit = (mail, firstName, lastName, role) => {
        var email = sanitizeEmailForId(mail);
        const selectedBranchId = getSelectedBranchId();
        const appliesToSelectedBranch = selectedBranchId && selectedBranchId !== 'all';
        return (
            <div className="modal fade" id={`modal-edit-${email}`} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>Modificación de rol</h4>
                        </div>
                        <div className="modal-body">
                            <p>Que rol deseas asignar a {firstName} {lastName}</p>
                            <p className="text-muted" style={{ fontSize: '13px', marginBottom: '10px' }}>
                                {appliesToSelectedBranch
                                    ? 'Este cambio aplica a la sucursal seleccionada actualmente.'
                                    : 'Con "Todos" seleccionado, este cambio modifica solo el rol global de respaldo.'}
                            </p>
                            <select id={`role-${email}`} className="custom-select" defaultValue={role}>
                                <option value="1">Administrador</option>
                                <option value="2">Encargado</option>
                                <option value="4">Finanzas</option>
                            </select>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cancelar
                            </button>
                            <button
                                className="mb-2 mr-1 btn btn-primary btn-sm"
                                data-dismiss="modal"
                                onClick={() => this.onEditItem(mail)}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    drawRow = (item, index) => {
        var email = sanitizeEmailForId(item.email);
        return (
            <tr role="row" className="odd" key={item.email} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.firstName}</td>
                <td>{item.lastName}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td className={getTextColorClassUsers(item.role)}>{getRoleName(item.role)}</td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            data-toggle="modal"
                            data-target={`#modal-branches-${email}`}
                            type="button"
                            className="btn btn-white">
                            <i className="material-icons">store</i>
                        </button>
                        <button
                            data-toggle="modal"
                            data-target={`#modal-edit-${email}`}
                            type="button"
                            className="btn btn-white"><i className="material-icons"></i>
                        </button>
                        <button
                            data-toggle="modal"
                            data-target={`#modal-remove-${email}`}
                            type="button"
                            className="btn btn-white">
                            <i className="material-icons"></i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    onDeleteItem = (email) => {
        if (this.state.totalItems > 1) {
            var request = {
                method: 'DELETE',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email })
            };
            fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'admin', request)
            .then(results => results.json())
            .then(data => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    this.fetchData();
                }
            });
        } else {
            alert('Debe haber al menos un administrador');
        }
    }

    onEditItem = (email) => {
        var emailFormated = sanitizeEmailForId(email);
        var role = document.getElementById(`role-${emailFormated}`).value;
        const selectedBranchId = getSelectedBranchId();
        const appliesToSelectedBranch = selectedBranchId && selectedBranchId !== 'all';
        const endpoint = appliesToSelectedBranch
            ? `branch/admin/${email}`
            : 'admin/updateRole';
        var request = {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(appliesToSelectedBranch
                ? {
                    branchId: Number(selectedBranchId),
                    role: parseInt(role)
                }
                : {
                    email: email,
                    role: parseInt(role)
                })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + endpoint, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.fetchData();
            }
        });
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <TableStateCard
                    icon="manage_accounts"
                    title="Todavia no hay administradores para mostrar"
                    message="Cuando existan administradores cargados, aca vas a ver sus datos, rol y configuracion por sucursal."
                />
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('firstName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '12%' }}>Nombre</th>
                            <th {...this.sortableHeader('lastName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '13%' }}>Apellido</th>
                            <th {...this.sortableHeader('email')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Correo</th>
                            <th {...this.sortableHeader('phone')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Teléfono</th>
                            {/* "Rol" no se ofrece como ordenable: el rol que se muestra es el efectivo
                                de la sucursal elegida, y el backend acepta sortBy=role pero lo baja a
                                firstName (AdminController). La flecha diría que ordenó y no sería cierto. */}
                            <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>{getSelectedBranchId() === 'all' ? 'Rol (global)' : 'Rol en esta sucursal'}</th>
                            <th rowSpan="1" colSpan="1">Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>
                {this.createModals()}

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableProductsComponent;
